export const getLocalStorage = (key: string) => {
  return window.localStorage.getItem(key);
};

export const setLocalStorage = (key: string, value: any) => {
  return window.localStorage.setItem(key, value);
};

export const deleteLocalStorage = (key: string) => {
  return window.localStorage.removeItem(key);
};
